import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { ScrollTop } from '@/components/element/ScrollTop';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { useCurrentSalesOrder } from '@/providers/SalesOrderProvider';
import { useCurrentSalesOrderContractTask } from '@/providers/SalesOrderContractTaskProvider';
import { SalesOrderContractTaskEditForm } from '@/components/features/tasks/sales_order_contract/[sales_order_contract_task_id]/SalesOrderContractTaskEditForm';

export const SalesOrderContractTaskEdit = () => {
  const { _w_, _t_ } = useCurrentTeamMember();
  const { _so_ } = useCurrentSalesOrder();
  const { setTitle, setBreadcrumbs } = useNavState();
  const { salesOrderContractTask: task } = useCurrentSalesOrderContractTask();
  useEffect(() => setTitle(`契約申請（売上）タスク編集`), []);
  useEffect(
    () =>
      setBreadcrumbs([
        { label: `プロジェクト（売上） - ${_t_!.name}`, path: `/w/${_w_!.identifier}/teams/${_t_!.id}/sales_orders` },
        { label: `プロジェクト（売上）詳細`, path: `/w/${_w_!.identifier}/teams/${_t_!.id}/sales_orders/${_so_!.id}` },
        {
          label: `契約申請（売上）タスク詳細`,
          path: `/w/${_w_!.identifier}/teams/${_t_!.id}/sales_orders/${_so_!.id}/sales_order_contract_tasks/${
            task!.id
          }`,
        },
      ]),
    []
  );

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <SalesOrderContractTaskEditForm />
    </WorkspaceLayout>
  );
};
